<template>
  <v-card>
    <v-card-title v-if="course.descriptionHeading">
      {{ course.descriptionHeading }}
    </v-card-title>
    <v-card-subtitle v-if="course.description">{{
      course.description
    }}</v-card-subtitle>
    <v-card-text>
      <v-row>
        <v-col cols="12" lg="6">
          <v-subheader>Course Info</v-subheader>
          <v-simple-table>
            <tbody>
              <tr>
                <td>Center</td>
                <td>
                  {{ course.center ? course.center.name : "N/A" || "N/A" }}
                </td>
              </tr>
              <tr>
                <td>Schedule</td>
                <td>
                  <span v-if="course.scheduleStart"
                    >{{ course.scheduleStart | formatDate }} to
                    {{ course.scheduleEnd | formatDate }}</span
                  >
                  <span v-else>N/A</span>
                </td>
              </tr>
              <tr>
                <td>Program</td>
                <td>
                  {{
                    course.courseProgram
                      ? course.courseProgram.name
                      : "N/A" || "N/A"
                  }}
                </td>
              </tr>
              <tr>
                <td>Subject</td>
                <td>{{ course.subject || "N/A" }}</td>
              </tr>
              <tr>
                <td>Grade</td>
                <td>{{ course.grade || "N/A" }}</td>
              </tr>
              <tr>
                <td>Price</td>
                <td>{{ course.price | currency }}/{{ rateUnit }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
        <v-col cols="12" lg="6">
          <v-subheader>Google Classroom Info</v-subheader>
          <v-simple-table>
            <tbody>
              <tr>
                <td>Enrollment code</td>
                <td>{{ course.enrollmentCode }}</td>
              </tr>

              <tr>
                <td>Google Classroom ID</td>
                <td>
                  {{ course.googleCourseId || "Not on Google Classroom" }}
                </td>
              </tr>

              <tr>
                <td>Owner:</td>
                <td>
                  {{ course.courseOwner ? course.courseOwner.name : "N/A" }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <div class="d-flex flex-row-reverse mt-5">
            <v-btn
              v-if="course.calendarId"
              target="_blank"
              :href="calendarLink"
              small
              outlined
              class="ml-5"
            >
              <v-icon class="mr-3">mdi-calendar-outline</v-icon>Calendar
            </v-btn>
            <v-btn
              v-if="course.googleDrive"
              target="_blank"
              :href="course.googleDrive"
              small
              outlined
            >
              <v-icon class="mr-3">mdi-folder-outline</v-icon>Drive
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  filters: {
    formatDate(date) {
      const momentDate = moment(date);
      if (momentDate.isValid()) {
        return momentDate.format("ddd, MMM DD, yyyy");
      } else {
        return "N/A";
      }
    },
  },
  computed: {
    calendarLink() {
      return `https://calendar.google.com/render?cid=${this.course.calendarId}&authuser=0`;
    },
    rateUnit() {
      const payTerm = this.course.courseProgram
        ? this.course.courseProgram.payTerm
        : "";
      if (payTerm == "subscription") {
        return "Month";
      } else if (payTerm == "session") {
        return "Session";
      } else if (payTerm == "flat-rate") {
        return "Course";
      }
      return "";
    },
  },
};
</script>

<style>
</style>